import { useEffect } from 'react';

import { CampaignDto } from '@shared/services/apiService/apiService';
import { useAppDispatch } from '@shared/store';
import { actions } from '@shared/store/ducks';

export const useEditCampaignLayout = (campaignData?: CampaignDto) => {
  const dispatch = useAppDispatch();
  const squadAgents = campaignData?.squad?.agents;
  const hasSquadAgentsList = Array.isArray(squadAgents);
  const agentCount = hasSquadAgentsList ? squadAgents.length : (campaignData?.agentsCount ?? 0);

  useEffect(() => {
    dispatch(actions.breadcrumbs.setIsShownBreadcrumbs(true));
    dispatch(
      actions.breadcrumbs.setBreadcrumb({
        pageTitle: 'campaignPage.header.campaignNameWithAgents',
        titleValue: {
          campaignName: campaignData?.title,
          count: agentCount,
        },
        campaigntype: campaignData?.type,
      }),
    );

    return () => {
      dispatch(actions.breadcrumbs.setIsShownBreadcrumbs(false));
    };
  }, [dispatch, campaignData, agentCount]);

  useEffect(() => {
    dispatch(actions.customizer.toggleLayout('full'));
    dispatch(actions.customizer.toggleEditCampaignView(true));
    dispatch(actions.customizer.setCollapse(true));

    return () => {
      dispatch(actions.customizer.toggleLayout('boxed'));
      dispatch(actions.customizer.toggleEditCampaignView(false));
    };
  }, [dispatch]);
};
